<template>
    <div :class="[
        'consent-full',
        { 'is-animation-start': isAnimationStart }
    ]">
        <div class="wrapper">
            <div class="consent-full-flex flex flex-column flex-content-center bg-color-secondary">
                <div 
                    v-if="icons" 
                    :class="[
                        'consent-full-icons',
                        'flex',
                    ]"
                >
                    <IconConsent 
                        v-for="icon in icons"
                        :key="icon"
                        :type="icon"
                    />
                </div>
                <div class="consent-full-body">
                    <span 
                        v-bastards
                        class="fs-37 text-bold"
                        v-text="bodyText"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconConsent from '@/components/icon/IconConsent'

export default {
    components: {
        IconConsent
    },

    props: {
        bodyText: {
            type: String,
            required: false,
            default: ''
        },
        icons: {
            type: Array,
            required: false,
            default: () => []
        }
    },

    data() {
        return {
            isAnimationStart: false
        }
    },

    mounted() {
        setTimeout(() => {
            this.isAnimationStart = true
        }, 300)
    }
}
</script>

<style lang="scss">
.consent-full {
    padding: 15px 0 18px;

    &-flex {
        min-height: 262px;

        .is-ie & {
            padding-top: 50px;
        }
    }

    &-body {
        text-align: center;
        padding: 0 55px;
    }

    &-icons {
        padding-bottom: 25px;

        .icon-consent {
            @include transform(scale(.6));
            opacity: 0;
        }
    }

    .is-animation-start & {
        &-icons {
            .icon-consent {
                @for $i from 1 through 5 {
                    &:nth-child(#{$i}) {
                        animation: jumpOnScene .400s ease-out #{($i - 1) / 15}s;
                        animation-fill-mode: forwards;
                    }
                }
            }
        }
    }

    @media (max-width: $screen-mobile-landscape) {
        &-flex {
            padding: 30px 0;
        }

        &-body {
            [class^="fs-"] {
                font-size: 2.5rem;
            }
        }
    }
}

@include keyframes(jumpOnScene) {
    0% {
        @include transform(scale(.6));
        opacity: 0;
    }

    61% {
        @include transform(scale(1.2));
        opacity: 1;
    }

    100% {
        @include transform(scale(1));
        opacity: 1;
    }
}
</style>
